import React from 'react';

const Checkbox = (widgetProps) => {
    let checkProps = {...widgetProps};
    delete checkProps.helperText;
    delete checkProps.error;
    delete checkProps.value;
    delete checkProps.onChange;

    checkProps.checked = !!widgetProps.value;


    return <div className="input-form">
        
        <div className="form-group">  
             <div className="checkbox">          
                <input 
                        type="checkbox" 
                        {...checkProps} 
                        onChange={(e) => {
                            widgetProps.onChange({
                                target: {
                                    name: widgetProps.name,
                                    id: widgetProps.id,
                                    value: e.target.checked
                                }
                            });
                        }} 
                    />  
                <label>{widgetProps.label} {widgetProps.required && !widgetProps.disabled ? '*' : ''}</label>                        
             </div>
        </div>
        {widgetProps.helperText && (
            <div className={`helper-text ${widgetProps.error ? 'error' : ''}`}>
            {widgetProps.helperText}
            </div>
        )}
    </div>
}
export default Checkbox;